import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './main.routes';

export class MainController {
  /*@ngInject*/
  constructor($auth, $rootScope) {
    this.$rootScope = $rootScope;
    this.logout = () => { $auth.signOut(); };
    this.widthStyle = this.getWidthStyle($rootScope.isFullScreen);

    $rootScope.$watch('isFullScreen', newValue => {
      this.widthStyle = this.getWidthStyle(newValue);
    });
  }

  $onInit() {
  }

  getWidthStyle(isFullScreen) {
    if (isFullScreen) {
      return { 'width': '100%' };
    } else {
      return { 'width': 'calc(100% - 173px)' };
    }
  }
}

export default angular.module('leptonApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/main/main.component.js